import Vue from 'vue'
import { formatMoney } from '@shopify/theme-currency'
import { handleize } from '@/lib/util'
import cart from '@/lib/cart'
import state from '@/lib/appState'
import { trigger } from '@/lib/utils'

Vue.component('bundle-info', {
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: [String, Object],
      default: '',
    },
    currentProductHandle: {
      type: String,
      default: '',
    },
    bundleProduct: {
      type: Object,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
    includedProducts: {
      type: Array,
      default: () => [],
    },
    includedProductDescriptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      state,
      selectedIndex: 0,
      breakpoints: '(max-width: 767px)|(min-width: 768px)',
      isProcessing: false,
      sourceImages:
        this.includedProducts &&
        this.includedProducts[0]?.imageMobile &&
        this.includedProducts[0]?.imageDesktop
          ? [
            this.includedProducts[0]?.imageMobile,
            this.includedProducts[0]?.imageDesktop,
          ]
          : null,
      sourceVideos:
        this.includedProducts &&
        this.includedProducts[0]?.videoMobile &&
        this.includedProducts[0]?.videoDesktop
          ? [
            this.includedProducts[0]?.videoMobile,
            this.includedProducts[0]?.videoDesktop,
          ]
          : null,
      sourceAlt: '',
      videoSubtitles:
        this.includedProducts && this.includedProducts[0]?.videoSubtitles,
      showVideoVolumeButton: this.includedProducts && this.includedProducts[0]?.showVideoVolumeButton,
    }
  },
  computed: {
    firstBundleVariantAvailable() {
      if (!this.bundleProduct || !this.bundleProduct.available) {
        return
      }

      return this.bundleProduct.variants.find(
        (p) => p.available
      )
    },
    priceBundle() {
      return this.firstBundleVariantAvailable && this.firstBundleVariantAvailable.price
        ? formatMoney(
          this.firstBundleVariantAvailable.price,
          // eslint-disable-next-line no-template-curly-in-string
          '${{amount_no_decimals}}'
        )
        : null
    },
    comparePriceBundle() {
      return this.firstBundleVariantAvailable &&
      this.firstBundleVariantAvailable.compareAtPrice
        ? formatMoney(
          this.firstBundleVariantAvailable.compareAtPrice,
          // eslint-disable-next-line no-template-curly-in-string
          '${{amount_no_decimals}}'
        )
        : null
    },
    reserveQuantity() {
      return this.firstBundleVariantAvailable.reserveQuantity
        ? Number(this.firstBundleVariantAvailable.reserveQuantity.value)
        : 0
    },
    soldOut() {
      if (!this.firstBundleVariantAvailable) {
        return true
      }

      if (
        this.firstBundleVariantAvailable.available &&
        this.firstBundleVariantAvailable.inventoryQuantity <= 0
      ) {
        return false
      }

      return (
        this.firstBundleVariantAvailable.inventoryQuantity <
        this.reserveQuantity
      )
    },
  },
  methods: {
    getStepText(index) {
      return `STEP 0${index + 1}`
    },
    handleize,
    setTabSelectedIndex(id) {
      if (!this.includedProducts[id]) return

      this.selectedIndex = id
      this.videoSubtitles = this.includedProducts[id].videoSubtitles
      this.showVideoVolumeButton = this.includedProducts[id].showVideoVolumeButton

      if (
        this.includedProducts[id].imageMobile &&
        this.includedProducts[id].imageDesktop
      ) {
        this.sourceImages = [
          this.includedProducts[id].imageMobile,
          this.includedProducts[id].imageDesktop,
        ]
        this.sourceAlt = null
      } else {
        this.sourceImages = null
        this.sourceAlt = null
      }

      if (
        this.includedProducts[id].videoMobile &&
        this.includedProducts[id].videoDesktop
      ) {
        this.sourceVideos = [
          this.includedProducts[id].videoMobile,
          this.includedProducts[id].videoDesktop,
        ]
      } else {
        this.sourceVideos = null
      }
    },
    addToCart () {
      this.isProcessing = true
      cart.add([{
        id: this.firstBundleVariantAvailable.id,
        quantity: 1
      }]).then(() => {
        cart.get().then((data) => {
          state.cart = data
          trigger('mini-cart-open', document.body, data)
          this.isProcessing = false
          trigger('update-gwp', document.body)
        })
      })
    },
  },
})